import React, { useRef, useState } from "react";
import {
    I2cInput,
    I2cCheckboxGroup,
    I2cListItem,
    I2cCheckbox, I2cRadioGroup, I2cRadioButton
} from "@webcomponents/i2cwebcomponents/dist/react";
import "../../PrepaidComponents/Prepaid.scss";
import { Controller } from "react-hook-form";
import ErrorMessage from "../../../Components/SharedComponent/ErrorMessage/ErrorMessage";
import { cardServiceOption } from "./stringUtils";
import AppSelectionIcons from "../AppSelectionForProgram/AppSelectionIcons"
const AdditionalCardsAccessCode = ({ control, handleValueChanges, methods, errors, appSelectionForProgram }) => {

    const handleCheckboxChange = (event, fieldName) => {
        const SelectedNetworkValue = event;
        let updatedSelectedNetworks = [
            ...(methods.getValues(fieldName) ?? []),
        ];
        if (updatedSelectedNetworks.includes(SelectedNetworkValue)) {
            updatedSelectedNetworks = updatedSelectedNetworks.filter(
                (card) => card !== SelectedNetworkValue,
            );
        } else {
            updatedSelectedNetworks.push(SelectedNetworkValue);
        }
        methods.setValue(fieldName, updatedSelectedNetworks);
        methods.trigger();
        handleValueChanges();
    };
    return (
        <>
            <div i2c-grid="grid gap-md" className="section-space">
                <div i2c-grid="12">
                    <div className="sub-heading">
                        <span className="productIconFlex">
                            <span slot="label" className="organize-tooltip">
                                Manage Additional Cards
                            </span>
                            <AppSelectionIcons
                                appSelectionForProgram={appSelectionForProgram}
                                mobileLink="https://example.com/mobile-app-a"
                                webLink="https://example.com/web-app-a"
                            />
                        </span>
                    </div>
                </div>
                <div i2c-grid="12">
                    <div className="single-field-wrapper">
                        <Controller
                            name="card_management_feature_manage_additional_cards_feature_app_enable"
                            control={control}
                            render={({ field }) => (
                                <I2cRadioGroup
                                    label="Please confirm if you would like to enable this feature on the application."
                                    {...field}
                                    name="card_management_feature_manage_additional_cards_feature_app_enable"
                                    onI2cChange={(e) => {
                                        field.onChange(e);
                                        if(e.target.value === "No"){
                                            methods.setValue("card_management_feature_manage_additional_cards_feature_app_enable_custom","")
                                            methods.setValue("card_management_feature_manage_additional_cards_feature_required_for",[]) 
                                        }
                                        methods.trigger();
                                        handleValueChanges();
                                    }}
                                >
                                    {["Yes", "No"].map((bc, index) => (
                                        <I2cRadioButton
                                            key={index}
                                            checked={
                                                methods.watch("card_management_feature_manage_additional_cards_feature_app_enable") === bc
                                            }
                                            value={bc}
                                        >
                                            {bc}
                                        </I2cRadioButton>
                                    ))}
                                </I2cRadioGroup>
                            )}
                        />
                        <ErrorMessage
                            show={
                                errors.card_management_feature_manage_additional_cards_feature_app_enable &&
                                    methods.formState.touchedFields.card_management_feature_manage_additional_cards_feature_app_enable
                                    ? true
                                    : false
                            }
                            message={errors.card_management_feature_manage_additional_cards_feature_app_enable?.message ?? "Invalid input"}
                        />
                    </div>
                </div>
                {
                    methods.watch("card_management_feature_manage_additional_cards_feature_app_enable") === "Yes" && (
                        <>
                            <div i2c-grid="6@md">
                                <div className="single-field-wrapper">
                                    <Controller
                                        name="card_management_feature_manage_additional_cards_feature_app_enable_custom"
                                        control={control}
                                        render={({ field }) => (
                                            <I2cInput
                                                {...field}
                                                className="single-input-field"
                                                label="Enter Custom Name"
                                                placeholder="Leave blank for default name"
                                                onI2cInput={(e) => {
                                                    const value = e.target.value;
                                                    field.onChange(value);
                                                    handleValueChanges();
                                                }}
                                                size="large"
                                                name={"card_management_feature_manage_additional_cards_feature_app_enable_custom"}

                                            >
                                            </I2cInput>
                                        )}
                                    />
                                </div>
                            </div>
                            <div i2c-grid="12">
                                <div className="custom-label mb-8">
                                    This feature is required for:
                                </div>
                                <div className="single-field-wrapper">
                                    <Controller
                                        name="card_management_feature_manage_additional_cards_feature_required_for"
                                        control={control}
                                        render={({ field }) => (
                                            <>
                                                <I2cCheckboxGroup
                                                    {...field}
                                                    className="centeredCheckbox checkbox-margin"
                                                >
                                                    <div i2c-grid="grid gap-sm">
                                                        {["C-Holder Web", "C-Holder Mobile"].map((card, index) => (
                                                            <I2cListItem
                                                                key={index}
                                                                i2c-grid="6@md"
                                                                variant="receipt"
                                                                label={card}
                                                                sublabel=""
                                                                value=""
                                                                type="checkbox"
                                                                checked={methods
                                                                    .watch("card_management_feature_manage_additional_cards_feature_required_for")
                                                                    .includes(card)}
                                                                onI2cCheckboxClicked={(e) => {
                                                                    handleCheckboxChange(card, "card_management_feature_manage_additional_cards_feature_required_for");
                                                                }}
                                                            >

                                                                <I2cCheckbox
                                                                    slot="prefix"
                                                                    name="card_management_feature_manage_additional_cards_feature_required_for"
                                                                    filled
                                                                    value={card}
                                                                    label=""
                                                                    ignoreTab
                                                                    checked={methods
                                                                        .watch("card_management_feature_manage_additional_cards_feature_required_for")
                                                                        .includes(card)}
                                                                    className="customCheckbox"
                                                                ></I2cCheckbox>
                                                            </I2cListItem>
                                                        ))}
                                                    </div>
                                                </I2cCheckboxGroup>
                                                <ErrorMessage
                                                    show={
                                                        errors.card_management_feature_manage_additional_cards_feature_required_for &&
                                                            methods.formState.touchedFields.card_management_feature_manage_additional_cards_feature_required_for
                                                            ? true
                                                            : false
                                                    }
                                                    message={
                                                        errors.card_management_feature_manage_additional_cards_feature_required_for?.message ?? "Invalid input"
                                                    }
                                                />
                                            </>
                                        )}
                                    />
                                </div>
                            </div>

                        </>
                    )
                }
            </div>
            <div i2c-grid="grid gap-md" className="section-space">
                <div i2c-grid="12">
                    <div className="sub-heading">
                        <span className="productIconFlex">
                            <span slot="label" className="organize-tooltip">
                                Manage Access Code
                            </span>
                            <AppSelectionIcons
                                appSelectionForProgram={appSelectionForProgram}
                                mobileLink="https://example.com/mobile-app-a"
                                webLink="https://example.com/web-app-a"
                            />
                        </span>
                    </div>
                </div>
                <div i2c-grid="12">
                    <div className="single-field-wrapper">
                        <Controller
                            name="card_management_feature_manage_access_code_feature_app_enable"
                            control={control}
                            render={({ field }) => (
                                <I2cRadioGroup
                                    label="Please confirm if you would like to enable this feature on the application."
                                    {...field}
                                    name="card_management_feature_manage_access_code_feature_app_enable"
                                    onI2cChange={(e) => {
                                        field.onChange(e);
                                        if(e.target.value === "No"){
                                            methods.setValue("card_management_feature_manage_access_code_feature_app_enable_custom","")
                                            methods.setValue("card_management_feature_manage_access_code_feature_required_for",[]) 
                                            methods.setValue("card_management_feature_manage_access_code_features",[]) 
                                            methods.setValue("card_management_feature_manage_access_code_info_verification_for_code_access",[]) 
                                        }
                                        methods.trigger();
                                        handleValueChanges();
                                    }}
                                >
                                    {["Yes", "No"].map((bc, index) => (
                                        <I2cRadioButton
                                            key={index}
                                            checked={
                                                methods.watch("card_management_feature_manage_access_code_feature_app_enable") === bc
                                            }
                                            value={bc}
                                        >
                                            {bc}
                                        </I2cRadioButton>
                                    ))}
                                </I2cRadioGroup>
                            )}
                        />
                        <ErrorMessage
                            show={
                                errors.card_management_feature_manage_access_code_feature_app_enable &&
                                    methods.formState.touchedFields.card_management_feature_manage_access_code_feature_app_enable
                                    ? true
                                    : false
                            }
                            message={errors.card_management_feature_manage_access_code_feature_app_enable?.message ?? "Invalid input"}
                        />
                    </div>
                </div>
                {
                    methods.watch("card_management_feature_manage_access_code_feature_app_enable") === "Yes" && (
                        <>
                            <div i2c-grid="6@md">
                                <div className="single-field-wrapper">
                                    <Controller
                                        name="card_management_feature_manage_access_code_feature_app_enable_custom"
                                        control={control}
                                        render={({ field }) => (
                                            <I2cInput
                                                {...field}
                                                className="single-input-field"
                                                label="Enter Custom Name"
                                                placeholder="Leave blank for default name"
                                                onI2cInput={(e) => {
                                                    const value = e.target.value;
                                                    field.onChange(value);
                                                    handleValueChanges();
                                                }}
                                                size="large"
                                                name={"card_management_feature_manage_access_code_feature_app_enable_custom"}

                                            >
                                            </I2cInput>
                                        )}
                                    />
                                </div>
                            </div>
                            <div i2c-grid="12">
                                <div className="custom-label mb-8">
                                    This feature is required for:
                                </div>
                                <div className="single-field-wrapper">
                                    <Controller
                                        name="card_management_feature_manage_access_code_feature_required_for"
                                        control={control}
                                        render={({ field }) => (
                                            <>
                                                <I2cCheckboxGroup
                                                    {...field}
                                                    className="centeredCheckbox checkbox-margin"
                                                >
                                                    <div i2c-grid="grid gap-sm">
                                                        {["C-Holder Web", "C-Holder Mobile"].map((card, index) => (
                                                            <I2cListItem
                                                                key={index}
                                                                i2c-grid="6@md"
                                                                variant="receipt"
                                                                label={card}
                                                                sublabel=""
                                                                value=""
                                                                type="checkbox"
                                                                checked={methods
                                                                    .watch("card_management_feature_manage_access_code_feature_required_for")
                                                                    .includes(card)}
                                                                onI2cCheckboxClicked={(e) => {
                                                                    handleCheckboxChange(card, "card_management_feature_manage_access_code_feature_required_for");
                                                                }}
                                                            >

                                                                <I2cCheckbox
                                                                    slot="prefix"
                                                                    name="card_management_feature_manage_access_code_feature_required_for"
                                                                    filled
                                                                    value={card}
                                                                    label=""
                                                                    ignoreTab
                                                                    checked={methods
                                                                        .watch("card_management_feature_manage_access_code_feature_required_for")
                                                                        .includes(card)}
                                                                    className="customCheckbox"
                                                                ></I2cCheckbox>
                                                            </I2cListItem>
                                                        ))}
                                                    </div>
                                                </I2cCheckboxGroup>
                                                <ErrorMessage
                                                    show={
                                                        errors.card_management_feature_manage_access_code_feature_required_for &&
                                                            methods.formState.touchedFields.card_management_feature_manage_access_code_feature_required_for
                                                            ? true
                                                            : false
                                                    }
                                                    message={
                                                        errors.card_management_feature_manage_access_code_feature_required_for?.message ?? "Invalid input"
                                                    }
                                                />
                                            </>
                                        )}
                                    />
                                </div>
                            </div>

                            <div i2c-grid="12">
                                <div className="custom-label mb-8">
                                    If yes, please specify the features you would like to use.
                                </div>
                                <div className="single-field-wrapper">
                                    <Controller
                                        name="card_management_feature_manage_access_code_features"
                                        control={control}
                                        render={({ field }) => (
                                            <>
                                                <I2cCheckboxGroup
                                                    {...field}
                                                    className="centeredCheckbox checkbox-margin"
                                                >
                                                    <div i2c-grid="grid gap-sm">
                                                        {["Change Access Code", "Send Access Code"].map((card, index) => (
                                                            <I2cListItem
                                                                key={index}
                                                                i2c-grid="4@md"
                                                                variant="receipt"
                                                                label={card}
                                                                sublabel=""
                                                                value=""
                                                                type="checkbox"
                                                                checked={methods
                                                                    .watch("card_management_feature_manage_access_code_features")
                                                                    .includes(card)}
                                                                onI2cCheckboxClicked={(e) => {
                                                                    handleCheckboxChange(card, "card_management_feature_manage_access_code_features");
                                                                }}
                                                            >

                                                                <I2cCheckbox
                                                                    slot="prefix"
                                                                    name="card_management_feature_manage_access_code_features"
                                                                    filled
                                                                    value={card}
                                                                    label=""
                                                                    ignoreTab
                                                                    checked={methods
                                                                        .watch("card_management_feature_manage_access_code_features")
                                                                        .includes(card)}
                                                                    className="customCheckbox"
                                                                ></I2cCheckbox>
                                                            </I2cListItem>
                                                        ))}
                                                    </div>
                                                </I2cCheckboxGroup>
                                                <ErrorMessage
                                                    show={
                                                        errors.card_management_feature_manage_access_code_features &&
                                                            methods.formState.touchedFields.card_management_feature_manage_access_code_features
                                                            ? true
                                                            : false
                                                    }
                                                    message={
                                                        errors.card_management_feature_manage_access_code_features?.message ?? "Invalid input"
                                                    }
                                                />
                                            </>
                                        )}
                                    />
                                </div>
                            </div>
                            <div i2c-grid="12">
                                <div className="custom-label mb-8">
                                    Please select the fields that cardholders must verify to change the Access Code.
                                </div>
                                <div className="single-field-wrapper">
                                    <Controller
                                        name="card_management_feature_manage_access_code_info_verification_for_code_access"
                                        control={control}
                                        render={({ field }) => (
                                            <>
                                                <I2cCheckboxGroup
                                                    {...field}
                                                    className="centeredCheckbox checkbox-margin"
                                                >
                                                    <div i2c-grid="grid gap-sm">
                                                        {["Last 4 digits of SSN [for US only]", "Expiration Date", "Date of Birth", "Password"].map((card, index) => (
                                                            <I2cListItem
                                                                key={index}
                                                                i2c-grid="4@md"
                                                                variant="receipt"
                                                                label={card}
                                                                sublabel=""
                                                                value=""
                                                                type="checkbox"
                                                                checked={methods
                                                                    .watch("card_management_feature_manage_access_code_info_verification_for_code_access")
                                                                    .includes(card)}
                                                                onI2cCheckboxClicked={(e) => {
                                                                    handleCheckboxChange(card, "card_management_feature_manage_access_code_info_verification_for_code_access");
                                                                }}
                                                            >

                                                                <I2cCheckbox
                                                                    slot="prefix"
                                                                    name="card_management_feature_manage_access_code_info_verification_for_code_access"
                                                                    filled
                                                                    value={card}
                                                                    label=""
                                                                    ignoreTab
                                                                    checked={methods
                                                                        .watch("card_management_feature_manage_access_code_info_verification_for_code_access")
                                                                        .includes(card)}
                                                                    className="customCheckbox"
                                                                ></I2cCheckbox>
                                                            </I2cListItem>
                                                        ))}
                                                    </div>
                                                </I2cCheckboxGroup>
                                                <ErrorMessage
                                                    show={
                                                        errors.card_management_feature_manage_access_code_info_verification_for_code_access &&
                                                            methods.formState.touchedFields.card_management_feature_manage_access_code_info_verification_for_code_access
                                                            ? true
                                                            : false
                                                    }
                                                    message={
                                                        errors.card_management_feature_manage_access_code_info_verification_for_code_access?.message ?? "Invalid input"
                                                    }
                                                />
                                            </>
                                        )}
                                    />
                                </div>
                            </div>
                        </>
                    )
                }
            </div>
            <div i2c-grid="grid gap-md" className="section-space">
                <div i2c-grid="12">
                    <div className="sub-heading">
                        <span className="productIconFlex">
                            <span slot="label" className="organize-tooltip">
                                Message Center
                            </span>
                            <AppSelectionIcons
                                appSelectionForProgram={appSelectionForProgram}
                                mobileLink="https://example.com/mobile-app-a"
                                webLink="https://example.com/web-app-a"
                            />
                        </span>
                    </div>
                </div>
                <div i2c-grid="12">
                    <div className="single-field-wrapper">
                        <Controller
                            name="card_management_feature_message_center_feature_app_enable"
                            control={control}
                            render={({ field }) => (
                                <I2cRadioGroup
                                    label="Please confirm if you would like to enable this feature on the application."
                                    {...field}
                                    name="card_management_feature_message_center_feature_app_enable"
                                    onI2cChange={(e) => {
                                        field.onChange(e);
                                        if(e.target.value === "No"){
                                            methods.setValue("card_management_feature_message_center_feature_app_enable_custom","")
                                            methods.setValue("card_management_feature_message_center_feature_required_for",[]) 
                                        }
                                        methods.trigger();
                                        handleValueChanges();
                                    }}
                                >
                                    {["Yes", "No"].map((bc, index) => (
                                        <I2cRadioButton
                                            key={index}
                                            checked={
                                                methods.watch("card_management_feature_message_center_feature_app_enable") === bc
                                            }
                                            value={bc}
                                        >
                                            {bc}
                                        </I2cRadioButton>
                                    ))}
                                </I2cRadioGroup>
                            )}
                        />
                        <ErrorMessage
                            show={
                                errors.card_management_feature_message_center_feature_app_enable &&
                                    methods.formState.touchedFields.card_management_feature_message_center_feature_app_enable
                                    ? true
                                    : false
                            }
                            message={errors.card_management_feature_message_center_feature_app_enable?.message ?? "Invalid input"}
                        />
                    </div>
                </div>
                {
                    methods.watch("card_management_feature_message_center_feature_app_enable") === "Yes" && (
                        <>
                            <div i2c-grid="6@md">
                                <div className="single-field-wrapper">
                                    <Controller
                                        name="card_management_feature_message_center_feature_app_enable_custom"
                                        control={control}
                                        render={({ field }) => (
                                            <I2cInput
                                                {...field}
                                                className="single-input-field"
                                                label="Enter Custom Name"
                                                placeholder="Leave blank for default name"
                                                onI2cInput={(e) => {
                                                    const value = e.target.value;
                                                    field.onChange(value);
                                                    handleValueChanges();
                                                }}
                                                size="large"
                                                name={"card_management_feature_message_center_feature_app_enable_custom"}

                                            >
                                            </I2cInput>
                                        )}
                                    />
                                </div>
                            </div>
                            <div i2c-grid="12">
                                <div className="custom-label mb-8">
                                    This feature is required for:
                                </div>
                                <div className="single-field-wrapper">
                                    <Controller
                                        name="card_management_feature_message_center_feature_required_for"
                                        control={control}
                                        render={({ field }) => (
                                            <>
                                                <I2cCheckboxGroup
                                                    {...field}
                                                    className="centeredCheckbox checkbox-margin"
                                                >
                                                    <div i2c-grid="grid gap-sm">
                                                        {["C-Holder Web", "C-Holder Mobile"].map((card, index) => (
                                                            <I2cListItem
                                                                key={index}
                                                                i2c-grid="6@md"
                                                                variant="receipt"
                                                                label={card}
                                                                sublabel=""
                                                                value=""
                                                                type="checkbox"
                                                                checked={methods
                                                                    .watch("card_management_feature_message_center_feature_required_for")
                                                                    .includes(card)}
                                                                onI2cCheckboxClicked={(e) => {
                                                                    handleCheckboxChange(card, "card_management_feature_message_center_feature_required_for");
                                                                }}
                                                            >

                                                                <I2cCheckbox
                                                                    slot="prefix"
                                                                    name="card_management_feature_message_center_feature_required_for"
                                                                    filled
                                                                    value={card}
                                                                    label=""
                                                                    ignoreTab
                                                                    checked={methods
                                                                        .watch("card_management_feature_message_center_feature_required_for")
                                                                        .includes(card)}
                                                                    className="customCheckbox"
                                                                ></I2cCheckbox>
                                                            </I2cListItem>
                                                        ))}
                                                    </div>
                                                </I2cCheckboxGroup>
                                                <ErrorMessage
                                                    show={
                                                        errors.card_management_feature_message_center_feature_required_for &&
                                                            methods.formState.touchedFields.card_management_feature_message_center_feature_required_for
                                                            ? true
                                                            : false
                                                    }
                                                    message={
                                                        errors.card_management_feature_message_center_feature_required_for?.message ?? "Invalid input"
                                                    }
                                                />
                                            </>
                                        )}
                                    />
                                </div>
                            </div>
                        </>
                    )
                }
            </div>
            <div i2c-grid="grid gap-md" className="section-space">
                <div i2c-grid="12">
                    <div className="sub-heading">
                        <span className="productIconFlex">
                            <span slot="label" className="organize-tooltip">
                                Additional Services
                            </span>
                            <AppSelectionIcons
                                appSelectionForProgram={appSelectionForProgram}
                                mobileLink="https://example.com/mobile-app-a"
                                webLink="https://example.com/web-app-a"
                            />
                        </span>
                    </div> 
                </div>
                <div i2c-grid="6@md">
                    <div className="single-field-wrapper">
                        <Controller
                            name="card_management_feature_additional_service"
                            control={control}
                            render={({ field }) => (
                                <I2cInput
                                    {...field}
                                    className="single-input-field"
                                    label="Please specify any additional services that you would like to opt for."
                                    placeholder="Leave blank for default name"
                                    onI2cInput={(e) => {
                                        const value = e.target.value;
                                        field.onChange(value);
                                        handleValueChanges();
                                    }}
                                    size="large"
                                    name={"card_management_feature_additional_service"}

                                >
                                </I2cInput>
                            )}
                        />
                    </div>
                </div>
            </div>
        </>
    );
};

export default AdditionalCardsAccessCode;
